/* eslint import/prefer-default-export:off */
export const socialLinks = {
    facebook: 'https://www.facebook.com/LowerMyBills/',
    twitter: 'https://twitter.com/lowermybills',
    pinterest: 'https://www.pinterest.com/lowermybills/',
    youtube: 'https://www.youtube.com/c/LowerMyBills',
    instagram: 'https://www.instagram.com/lowermybills/',
};
